export default "__VITE_ASSET__61f89ff5__"